import Box from '~/core/Box'
import Text from '~/core/Text'
import icons from '~/apps/consumer/icons'
import Image from '~/core/Image'
type PremiumTrialActivationBannerType = {
    title: string
}

function PremiumTrialActivationBanner(props: PremiumTrialActivationBannerType) {
    const { title } = props

    return (
        <Box
            alignItems="center"
            direction="col"
            position="relative"
            paddingBottom="8px"
            marginTop="200px"
        >
            <Image
                src={icons.checkMark}
                style={{ marginBottom: '16px' }}
                width="84px"
                height="84px"
            />
            <Text
                fontWeight={600}
                fontSize="24px"
                style={{
                    lineHeight: '32px',
                    marginTop: '8px',
                    textAlign: 'center',
                }}
            >
                {title}
            </Text>
        </Box>
    )
}

export default PremiumTrialActivationBanner
